import { createAction } from "@reduxjs/toolkit";

export const updateAvailableRequest = createAction(
  "user/UPDATE_AVAILABLE_REQUEST",
);

export const deletedAvailableRequest = createAction(
  "user/DELETE_FUTURE_AVAILABILITY",
);
